import { defineStyleConfig, } from '@chakra-ui/react';
import { ThemeColorToken } from '../theme-tokens';
const baseStyle = {
    borderColor: ThemeColorToken.OnBackgroundBorder,
    m: 0,
    opacity: 1,
};
export const dividerConfig = defineStyleConfig({
    baseStyle,
});
//# sourceMappingURL=divider-theme.js.map